/** @type {import("../typings/phaser")} */

import {LoadScene} from "./scenes/LoadScene";
import {MenuScene} from "./scenes/MenuScene";
import {SoundtrackScene} from "./scenes/SoundtrackScene";
import { BirthScene } from "./scenes/BirthScene";
import { SchoolScene } from "./scenes/SchoolScene";
import { PubertyScene } from "./scenes/PubertyScene";
import { TalkScene } from "./scenes/TalkScene";
import { CoffeeScene } from "./scenes/CoffeeScene";
import { FindherScene } from "./scenes/FindherScene";
import { MarriageScene } from "./scenes/MarriageScene";
import { KidsScene } from "./scenes/KidsScene";
import { CredistScene } from "./scenes/CreditsScene";
import { DieScene } from "./scenes/DieScene";
import { PillsScene } from "./scenes/PillsScene";
import { MidlifeScene } from "./scenes/MidlifeScene";
import { GrandchildrenScene } from "./scenes/GrandchildrenScene";
import { BeerpongScene } from "./scenes/BeerpongScene";
import { ProgressiveLoadScene } from "./scenes/ProgressiveLoadScene";
import { InstrumentScene } from "./scenes/InstrumentScene";
import { ArcadeMinigameLoadingScene } from "./scenes/ArcadeMinigameLoadingScene"; 
import { GridFillScene } from "./scenes/GridFillScene";
import { DistractionScene } from "./scenes/DistractionScene";
import { BurgerScene } from "./scenes/BurgerScene";
import { RemoteConfigPlugin } from "./plugins/RemoteConfigPlugin";
import { AudioPlugin } from "./plugins/AudioPlugin";
import { StoragePlugin } from "./plugins/StoragePlugin";

let game = new Phaser.Game({
    width: 853,
    height: 480,
    plugins: {
        global: [
            { key: "StoragePlugin", plugin: StoragePlugin, mapping: 'storagePlugin', start: true},
            { key: "RemoteConfigPlugin", plugin: RemoteConfigPlugin, mapping: 'remoteConf', start: true},
            { key: "AudioPlugin", plugin: AudioPlugin, mapping: 'audioPlugin', start: true},
        ] 
    },
    scale: {
        mode: Phaser.Scale.FIT,
    },
    scene: [
        LoadScene,
        ProgressiveLoadScene,
        SoundtrackScene,
        MenuScene,
        ArcadeMinigameLoadingScene,
        BirthScene,
        TalkScene,
        SchoolScene,
        PubertyScene,
        FindherScene,
        BeerpongScene,
        CoffeeScene,
        MarriageScene,
        KidsScene,
        MidlifeScene,
        GrandchildrenScene,
        PillsScene,
        DieScene,
        CredistScene,

        InstrumentScene,
        GridFillScene,
        DistractionScene,
        BurgerScene,
    ],

    physics: {
        default: "matter",
        matter: {
            debug: false
        }
    }
});

